"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modRiskCategoryDictionaryResponse = exports.modRiskCategoryRowValues = void 0;
exports.modRiskCategoryRowValues = [
    {
        ROLE: "PAYMENT",
        MODIFIER: "22",
        DESCRIPTION: "INCREASED PROCEDURAL SERVICE",
        CATEGORY: "CORRECT",
        Key: "0",
        ASSESSMENT: "IDEAL"
    },
    {
        ROLE: "PAYMENT",
        MODIFIER: "22",
        DESCRIPTION: "INCREASED PROCEDURAL SERVICE",
        CATEGORY: "INCORRECT",
        Key: "1",
        ASSESSMENT: "NOT-IDEAL"
    },
    {
        ROLE: "PAYMENT",
        MODIFIER: "22",
        DESCRIPTION: "INCREASED PROCEDURAL SERVICE",
        CATEGORY: "MISSED",
        Key: "2",
        ASSESSMENT: "IDEAL"
    },
    {
        ROLE: "INFORMATIONAL",
        MODIFIER: "LT",
        DESCRIPTION: "LEFT",
        CATEGORY: "CORRECT",
        Key: "66",
        ASSESSMENT: "IDEAL"
    },
    {
        ROLE: "INFORMATIONAL",
        MODIFIER: "LT",
        DESCRIPTION: "LEFT",
        CATEGORY: "INCORRECT",
        Key: "67",
        ASSESSMENT: "NOT-IDEAL"
    },
    {
        ROLE: "INFORMATIONAL",
        MODIFIER: "LT",
        DESCRIPTION: "LEFT",
        CATEGORY: "MISSED",
        Key: "68",
        ASSESSMENT: "IDEAL"
    },
    {
        ROLE: "INFORMATIONAL",
        MODIFIER: "RT",
        DESCRIPTION: "RIGHT",
        CATEGORY: "CORRECT",
        Key: "75",
        ASSESSMENT: "IDEAL"
    },
    {
        ROLE: "INFORMATIONAL",
        MODIFIER: "RT",
        DESCRIPTION: "RIGHT",
        CATEGORY: "INCORRECT",
        Key: "76",
        ASSESSMENT: "NOT-IDEAL"
    },
    {
        ROLE: "INFORMATIONAL",
        MODIFIER: "RT",
        DESCRIPTION: "RIGHT",
        CATEGORY: "MISSED",
        Key: "77",
        ASSESSMENT: "IDEAL"
    }
];
exports.modRiskCategoryDictionaryResponse = {
    numRows: 108,
    columnNames: [
        "DESCRIPTION",
        "CATEGORY",
        "ROLE",
        "MODIFIER",
        "Key",
        "ASSESSMENT"
    ],
    rowValues: exports.modRiskCategoryRowValues
};
//# sourceMappingURL=mod-risk-categories.js.map